package com.nonopn.skydome.common.app.navigation

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import com.nonopn.icons.Logout
import com.nonopn.skydome.common.app.api.Mode
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.estimate.EstimateScreen
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.menu_user_estimate_new
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.widgets.MenuItem
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

@Serializable
object RouteEstimateNew : RouteParameterTo

object RouterEstimateNew : RouterNoParameters<RouteEstimateNew>(RouteEstimateNew::class) {
    override fun routeFrom(parameters: RouteEstimateNew) =
        "/estimate/new"

    @Composable
    override fun Show(parameters: RouteEstimateNew) {
        RouteEstimateNewImpl(parameters).scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteEstimateNew,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(
                launchSingleTop = true
            )
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteEstimateNew

    override fun isMatching(route: String) = route == "/estimate/new"

    override fun navigateFrom(path: String) = RouteEstimateNew
}

class RouteEstimateNewImpl(params: RouteEstimateNew) : Route<RouteEstimateNew>(
    route = "/estimate/new",
    params = params,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current

        LaunchedEffect(Unit) {
            onEntryIsActive(appModel, emptyList())
        }

        EstimateScreen(
            modifier = Modifier.fillMaxSize(),
            appModel = appModel,
            mode = Mode.Normal,
        )
    }

    private fun onEntryIsActive(
        appModel: AppModel,
        defaultActions: List<MenuItem>,
    ) {
        appModel.setAppBarState(
            AppBarState.Localized(
                title = Res.string.menu_user_estimate_new,
                defaultActions + MenuItem.MenuItemSimple(
                    imageVector = Icons.Rounded.Logout,
                    onClick = {
                        // appModel.show(NavigateTo.Main())
                    }
                )
            )
        )
    }
}
